<!-- Loading -->
<ng-container *ngIf="sportTrainers == null">
    <div class="text-center">
        <span>
            <i class="fa-solid fa-spinner fa-spin"></i>
        </span>
    </div>
</ng-container>

<div class="d-flex flex-column gap-2">

    <!-- Loaded -->
    <ng-container *ngIf="sportTrainers != null">
        <!-- List with items -->
        <ng-container *ngFor="let sportTrainer of sportTrainers ; let  sportIndex = index">
            <app-collapsible-card [cardTitle]="sportTrainer.sportName">
                <div class="card-body p-0">
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item bg-light">
                            <p><b>{{ 'know-how.adminCardTitle' | transloco }}</b></p>
                        </li>
                        <li *ngFor="let sportTrainerAdmin of sportTrainer.trainerAdmins; let index = index"
                            class="list-group-item">
                            <div class="d-flex">
                                <div>
                                    <input id="admin-{{sportIndex}}-{{index}}"
                                        [(ngModel)]="sportTrainerAdmin.isSelected" type="checkbox" class="me-2"
                                        (ngModelChange)="selectionChanged(sportTrainer)"
                                        [disabled]="hasAnyTrainerSelected(sportTrainer)" />
                                </div>
                                <div class="d-flex flex-grow-1 justify-content-between gap-2">
                                    <div>
                                        <label for="admin-{{sportIndex}}-{{index}}" class="fw-regular">
                                            <div>
                                                <span>
                                                    {{ sportTrainerAdmin.firstName }} {{ sportTrainerAdmin.lastName }}
                                                </span>
                                                <span>
                                                    <span class="badge badge-secondary"
                                                        [tooltip]="'know-how.diciplinLead' | transloco"
                                                        *ngIf="sportTrainerAdmin.role == sportTrainerRoleEnum.DisciplineLeader">
                                                        {{'know-how.diciplinLeadShort' | transloco}}
                                                    </span>
                                                    <span class="badge badge-secondary"
                                                        [tooltip]="'know-how.admin' | transloco"
                                                        *ngIf="sportTrainerAdmin.role == sportTrainerRoleEnum.Admin">
                                                        {{'know-how.adminShort' | transloco}}
                                                    </span>
                                                </span>
                                            </div>
                                        </label>
                                    </div>
                                    <div>
                                        <div class="text-nowrap">{{ sportTrainerAdmin.phone }}</div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li class="list-group-item bg-light">
                            <p><b>{{ 'know-how.trainerCardTitle' | transloco }}</b></p>
                        </li>
                        <li class="list-group-item" *ngIf="sportTrainer.attributes?.length">
                            <div class="d-flex gap-2 flex-wrap">
                                <span class="badge" role="button"
                                    [ngClass]="isAttributeSelected(sportTrainer, attribute.id)  ? 'badge-primary' : 'badge-default'"
                                    *ngFor="let attribute of sportTrainer.attributes"
                                    (click)="toggleAttribute(sportTrainer, attribute.id)">
                                    {{attribute.name}}
                                </span>
                            </div>
                        </li>
                        <li *ngFor="let trainer of getFilteredTrainers(sportTrainer) let trainersIndex = index"
                            class="list-group-item">
                            <div class="d-flex">
                                <div>
                                    <input id="trainer-{{sportIndex}}-{{trainersIndex}}"
                                        [(ngModel)]="trainer.isSelected" type="checkbox" class="me-2"
                                        (ngModelChange)="selectionChanged(sportTrainer)" />
                                </div>
                                <div class="flex-grow-1 d-flex flex-column gap-1">
                                    <div class="d-flex justify-content-between gap-2">
                                        <div>
                                            <label for="trainer-{{sportIndex}}-{{trainersIndex}}" class="fw-regular">
                                                {{ trainer.firstName }} {{ trainer.lastName }}
                                            </label>
                                        </div>
                                        <div>
                                            <div class="text-nowrap">{{ trainer.phone }}</div>
                                        </div>
                                    </div>
                                    <div class="d-flex gap-2 flex-wrap" *ngIf="trainer.attributes?.length">
                                        <span class="badge" role="button"
                                            [ngClass]="isAttributeSelected(sportTrainer, attribute.id)  ? 'badge-primary' : 'badge-default'"
                                            *ngFor="let attribute of trainer.attributes"
                                            (click)="toggleAttribute(sportTrainer, attribute.id)">
                                            {{attribute.name}}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <div class="card-footer d-flex flex-wrap gap-2 p-2 justify-content-end">
                        <div class="btn-group" dropdown [isDisabled]="!hasSelectedContacts(sportTrainer)">
                            <button
                                class="btn btn-primary btn-sm"
                                [disabled]="!hasSelectedContacts(sportTrainer)"
                                (click)="sendMessageToSelected(sportTrainer)">
                                {{ 'know-how.mailToSelected' | transloco }}
                            </button>
                            <button class="btn btn-primary btn-sm dropdown-toggle dropdown-toggle-split" dropdownToggle></button>
                            <ul class="dropdown-menu dropdown-menu-end" *dropdownMenu>
                                <li>
                                    <button class="dropdown-item" (click)="sendMessageToSelected(sportTrainer)">
                                        {{'know-how.mailViaStaffTool' | transloco}}
                                    </button>
                                </li>
                                <li>
                                    <button class="dropdown-item" (click)="sendMessageToSelectedViaMailClient(sportTrainer)">
                                        {{'know-how.mailViaMailClient' | transloco}}
                                    </button>
                                </li>
                            </ul>
                        </div>
                        <div class="btn-group" dropdown>
                            <button class="btn btn-primary btn-sm" (click)="sendMessageToAll(sportTrainer)">
                                {{ isAnyFilterAcitve(sportTrainer)
                                    ? ('know-how.mailToAllFiltered' | transloco)
                                    : ('know-how.mailToAll' | transloco) }}
                            </button>
                            <button class="btn btn-primary btn-sm dropdown-toggle dropdown-toggle-split" dropdownToggle></button>
                            <ul class="dropdown-menu dropdown-menu-end" *dropdownMenu>
                                <li>
                                    <button class="dropdown-item" (click)="sendMessageToAll(sportTrainer)">
                                        {{'know-how.mailViaStaffTool' | transloco}}
                                    </button>
                                </li>
                                <li>
                                    <button class="dropdown-item" (click)="sendMessageToAllViaMailClient(sportTrainer)">
                                        {{'know-how.mailViaMailClient' | transloco}}
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </app-collapsible-card>
        </ng-container>

        <!-- Empty List -->
        <ng-container *ngIf="sportTrainers.length == 0">
            <div class="alert alert-secondary">
                {{ 'know-how.emptyList' | transloco }}
            </div>
        </ng-container>
    </ng-container>
</div>